// src/router/index.js

import { createRouter, createWebHashHistory } from 'vue-router'; // Changed from createWebHistory
import AddCharacter from '../components/AddCharacter.vue';
import CharacterDetails from '../components/CharacterDetails.vue';
import CharacterFavorite from '../components/CharacterFavorite.vue';
import CharacterList from '../components/CharacterList.vue';

const routes = [
  {
    path: '/',
    name: 'CharacterList',
    component: CharacterList,
  },
  {
    path: '/character/:id',
    name: 'CharacterDetails',
    component: CharacterDetails,
    props: true,
  },
  {
    path: '/add-character',
    name: 'AddCharacter',
    component: AddCharacter,
  },
  {
    path: '/favorites', 
    name: 'CharacterFavorite',
    component: CharacterFavorite,
  },
  // Redirect any unknown routes to home
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  // Use Hash History to fix refresh 404/directory listing issues
  history: createWebHashHistory(), 
  routes,
  // improved scroll behavior
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;